// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3RPf2","text":"SelectPayment_text__3Y2mE","title":"SelectPayment_title__1n9nZ","btn":"SelectPayment_btn__36M6D"};